<div class="compliance-details-container flex-column d-flex gap-4" *transloco="let t; prefix: 'compliance.library.details'">
  <div class="header">
    <div class="title-row">
      <button class="back-btn" type="button" [routerLink]="['/asset-management/compliance-library']" [attr.aria-label]="t('backToLibrary')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
              fill="#9FA1A4" />
          </svg>
      </button>
      <h2 class="title m-0 h3">{{ title }}</h2>
    </div>

    @if(activeTab === 'assignedAssets') {
      <div class="btn-containers gap-2">
        <app-search
          [placeholder]="t('searchPlaceholder')"
          [searchTerm]="searchTerm"
          [customWidth]="'240px'"
          (searchTermUpdated)="onSearchChanged($event)">
        </app-search>
        <app-asset-type-filter (typeChanged)="onAssetTypeChanged($event)"></app-asset-type-filter>
        <button class="assignment-btn" (click)="onAssignAssetsClick()">{{ t('assignAssets') }}</button>
      </div>
    } @else if(activeTab === 'requirements') {
      <div class="btn-containers">
        <button type="button" class="requirements-btn" (click)="onAddComplianceRequirementsClick()">{{ t('addComplianceCategory') }}</button>
      </div>
    }
  </div>

  <div class="cmn_tabWrap">
    <div class="cmn_tabWrapUl">
      <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" [class.active]="activeTab === 'requirements'"
            id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
            type="button" role="tab" aria-controls="pills-home" aria-selected="true"
            (click)="toggleTab('requirements')">
            {{ t('tabs.checklistRequirements') }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'assignedAssets'"
            id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
            type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
            (click)="toggleTab('assignedAssets')">
            {{ t('tabs.assignedAssets') }}
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'archive'"
            id="pills-archive-tab" data-bs-toggle="pill" data-bs-target="#pills-archive"
            type="button" role="tab" aria-controls="pills-archive" aria-selected="false"
            (click)="toggleTab('archive')">
            {{ t('tabs.archive') }}
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div class="tab-content-wrapper">
    @switch(activeTab) {
      @case('requirements') {
        <app-checklist-requirements #requirementsChecklist [complianceId]="complianceId"></app-checklist-requirements>
      }
      @case('assignedAssets') {
        <app-assigned-assets
          [complianceId]="complianceId"
          [complianceName]="complianceName"
          [complianceType]="complianceType"
          [searchTerm]="searchTerm"
          [assetType]="selectedAssetType">
        </app-assigned-assets>
      }
      @case('archive') {
        <app-checklist-requirements [complianceId]="complianceId" [isArchive]="true"></app-checklist-requirements>
      }
    }
  </div>
</div>